import React from "react";
import { ArrowUpRight } from "lucide-react";

const IMG = "https://customer-assets.emergentagent.com/job_practice-portal-15/artifacts/ctvvhsq4_%20-10.jpg";
const BOOKING_URL = "https://alchemy-practice.clientsecure.me/";

const steps = [
    {
        n: "01",
        title: "A quiet first conversation",
        body: "Our consultation is short, warm, and pressure-free. We talk about what's bringing you here — and decide together if it feels like a fit.",
    },
    {
        n: "02",
        title: "We move at your pace",
        body: "Nothing about this work is rushed. We begin where you are — gently — and let each session build on the last with care and intention.",
    },
    {
        n: "03",
        title: "A practice, not a performance",
        body: "You don't need the right words. You don't need to arrive composed. Therapy here is private, considered, and entirely yours.",
    },
];

export default function WhatToExpect() {
    return (
        <section id="what-to-expect" data-testid="what-to-expect-section" className="py-28 lg:py-40" style={{ background: "#EEF2ED" }}>
            <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    {/* Image */}
                    <div className="lg:col-span-5" data-reveal>
                        <div className="relative">
                            <img
                                src={IMG}
                                alt="A quiet, candlelit afternoon — tea, a blanket, and rest"
                                className="w-full h-[500px] lg:h-[640px] object-cover"
                            />
                            {/* gold corner ornament */}
                            <div className="absolute -bottom-5 -left-5 hidden md:block">
                                <span className="font-serif text-gold text-6xl leading-none">✦</span>
                            </div>
                        </div>
                    </div>

                    {/* Copy */}
                    <div className="lg:col-span-7 lg:pl-6" data-reveal>
                        <span className="editorial-eyebrow">What to expect</span>
                        <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-charcoal text-balance">
                            The first step is the <em className="italic text-gold">softest</em> one.
                        </h2>

                        <div className="mt-10 hairline" />

                        <p className="mt-10 max-w-xl text-lg text-charcoal-soft leading-[1.85]">
                            Beginning therapy doesn't have to feel like a leap. It can feel like sitting
                            down with a warm cup, breathing once, and starting a quiet conversation.
                        </p>

                        <ol className="mt-14 space-y-10" data-testid="what-to-expect-steps">
                            {steps.map((s) => (
                                <li key={s.n} className="grid grid-cols-[auto_1fr] gap-x-8 gap-y-2 items-start">
                                    <span className="font-serif text-3xl text-gold leading-none mt-1">{s.n}</span>
                                    <div>
                                        <h3 className="font-serif text-2xl sm:text-3xl text-charcoal">{s.title}</h3>
                                        <p className="mt-3 text-charcoal-soft leading-relaxed max-w-xl">{s.body}</p>
                                    </div>
                                </li>
                            ))}
                        </ol>

                        <a
                            href={BOOKING_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="what-to-expect-book-button"
                            className="mt-14 editorial-button-primary group"
                        >
                            Begin When You're Ready
                            <ArrowUpRight size={16} strokeWidth={1.25} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
